import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';

@Pipe({name: 'amFromISO'})
export class FromISOPipe implements PipeTransform {
  public transform(value: any, ...args: string[]): any {
    if (!value) {
      return '';
    }
    return moment(value).format('YYYY-MM-DDTHH:mm:ss');
  }
}
